<template>
  <div class="indexPage custom_style">
    <div class="head flex-rowl">
      <i class="iconfont icon-goutongjiaoliu"></i>
      <div class="content">
        <h1>触达记录</h1>
        <p>添加/编辑客户触达记录</p>
      </div>
    </div>
    <div class="container_wrap">
      <div class="form_wrap">
        <div class="block info">
          <div class="txt flex-rowl">
            <p class="label">客户名称：</p>
            <p>
              {{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
          </div>
          <div class="txt flex-rowl">
            <p class="label">企业名称：</p>
            <div class="cont">
              <p>{{ customerDetail.other_companystr }}</p>
              <div class="edit_wrap">
                <div class="check_box">
                  <van-checkbox v-model="isEditCompany" icon-size="18px" :disabled="idc != 0"
                    >是否变更</van-checkbox
                  >
                </div>
                <div
                  class="select flex-between"
                  v-if="isEditCompany"
                  @click="handleShow(7)"
                >
                  <van-field
                    v-model="other_companyStr"
                    placeholder="请输入企业名称"
                    readonly
                  />
                  <i class="iconfont icon-bottom"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="txt flex-rowl">
            <p class="label">职务：</p>
            <div class="cont">
              <p>{{ customerDetail.other_job }}</p>
              <div class="edit_wrap">
                <div class="check_box">
                  <van-checkbox v-model="isEditJob" icon-size="18px" :disabled="idc != 0"
                    >是否变更</van-checkbox
                  >
                </div>
                <div class="input" v-if="isEditJob">
                  <van-field
                    v-model="formData.other_job"
                    placeholder="输入职务"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="txt flex-rowl">
            <p class="label">联系方式：</p>
            <div class="cont">
              <p>{{ customerDetail.info_mobile }}</p>
              <div class="edit_wrap">
                <div class="check_box">
                  <van-checkbox v-model="isEditMobile" icon-size="18px" :disabled="idc != 0"
                    >是否变更</van-checkbox
                  >
                </div>
                <div class="input" v-if="isEditMobile">
                  <van-field
                    v-model="formData.mobile"
                    placeholder="输入联系方式"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title flex-rowl">
            <i class="iconfont icon-zixunjieda"></i>
            触达记录详情
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(1)">
              <van-field
                v-model="getstatestr"
                placeholder="最近联系情况"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(2)">
              <van-field v-model="gettypestr" placeholder="联系形式" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="input flex-between" @click="handleShow(3)">
              <van-field v-model="resultstr" placeholder="联系结果" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item detail">
            <div class="tit">情况说明：</div>
            <div class="textarea">
              <van-field
                v-model="formData.details"
                type="textarea"
                placeholder="请填写情况说明"
                :disabled="idc != 0"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="custom_btn" @click="query" v-if="idc == 0">保存</div>
    </div>
    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <!-- 弹窗 start -->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <!-- 行业标签1 -->
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="linkConditionOption"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div v-else-if="isType == 2">
        <van-picker
          show-toolbar
          :columns="linkTypeOption"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="linkResultOption"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
      <div v-else-if="isType == 7">
        <van-picker
          show-toolbar
          :columns="customerQy"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>
<script>
import {
  getQywxset,
  getCustomerDetail,
  getCustomerGenDetail,
  editCustomerGen,
  addCustomerGen,
  encryptstringview,
} from "../../../api/api";
import { getCustomQyList } from "../../../api/company";
import { mapState } from "vuex";
export default {
  name: "rServiceAddRecord",
  data() {
    return {
      isShow: false, // 是否显示弹窗
      isType: 1, // 显示弹窗类型

      id: "",
      idc: "",
      loading: false,
      formData: {
        openid: this.$store.state.OPENID,
        customerid: "",
        // createdate: "",
        getstate: "",
        gettype: "",
        result: "",
        details: "",
        others: "",
        mobile: "",
        other_company: "",
        other_job: "",
      },
      other_companyStr: '',
      customerDetail: "", // 客户详情

      getstatestr: "",
      linkConditionOption: [], // 联系情况
      gettypestr: "",
      linkTypeOption: [], // 联系形式
      resultstr: "",
      linkResultOption: [], // 联系结果
      customerQy: [],

      isEditCompany: false, // 是否修改企业
      isEditJob: false, // 是否修改职务
      isEditMobile: false, // 是否修改联系方式
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, idC } = JSON.parse(res.jsondata);
        this.id = id;
        this.idc = idC;
        this.formData.customerid = id;
        this.getCustomerDetail();
        if (this.idc != 0) {
          this.getCustomerGenDetail();
        }
      } else {
        this.$router.back();
      }
    },

    // 获取触达详情
    getCustomerGenDetail() {
      getCustomerGenDetail({ id: this.idc }).then((res) => {
        this.formData.customerid = res.customerid;
        this.formData.id = res.id;
        this.formData.getstate = res.getstate;
        this.getstatestr = res.getstatestr;
        this.formData.gettype = res.gettype;
        this.gettypestr = res.gettypestr;
        this.formData.result = res.result;
        this.resultstr = res.resultstr;
        this.formData.details = res.details;
        this.formData.others = res.others;
        this.formData.other_company = res.other_company;
        this.formData.other_job = res.other_job;
        this.formData.mobile = res.mobile;
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        console.log(res, "=========eeee");
        this.customerDetail = res;
      });
    },

    getQywxset(isShow) {
      let { isType } = this;
      let columncode = "";
      if (isType == 1) {
        columncode = "contactresult"; // 联系情况
      } else if (isType == 2) {
        columncode = "linktype"; // 联系形式
      } else if (isType == 3) {
        columncode = "linkresult"; // 联系结果
      }
      getQywxset(columncode).then((res) => {
        res.forEach((item) => {
          if (isType == 1) {
            this.linkConditionOption.push({
              text: item.evalue,
              value: item.id,
            });
          } else if (isType == 2) {
            this.linkTypeOption.push({
              text: item.evalue,
              value: item.id,
            });
          } else if (isType == 3) {
            this.linkResultOption.push({
              text: item.evalue,
              value: item.id,
            });
          }
        });
        if (isShow) {
          this.isShow = true;
        }
      });
    },

    // 显示弹窗
    handleShow(type) {
      let {idc} = this
      if(idc != 0) return
      this.isType = type;
      if (type == 7) {
        this.getCustomQyList();
      } else {
        this.getQywxset(true);
      }
    },
    onConfirm(e) {
      let { isType } = this;
      let { text, value } = e;
      console.log(value);
      if (isType == 1) {
        this.formData.getstate = value;
        this.getstatestr = text;
      } else if (isType == 2) {
        this.formData.gettype = value;
        this.gettypestr = text;
      } else if (isType == 3) {
        this.formData.result = value;
        this.resultstr = text;
      } else if (isType == 7) {
        this.formData.other_company = value;
        this.other_companyStr = text;
      }
      this.isShow = false;
    },

    // 企业
    getCustomQyList() {
      getCustomQyList({ qyguid: this.qyguid }).then((res) => {
        let newArr = [];
        res.list.forEach((v) => {
          newArr.push({
            text: v.bodyname,
            value: v.bodyqyguid,
          });
        });
        this.customerQy = newArr;
        this.isShow = true;
      });
    },

    query() {
      let { formData, idc } = this;
      console.log(formData,'-==-=');
      if (formData.getstate == "") {
        this.$toast("请输入最近联系情况 ");
        return;
      }
      if (formData.gettype == "") {
        this.$toast("请输入联系形式");
        return;
      }
      if (formData.result == "") {
        this.$toast("请输入联系结果");
        return;
      }
      if (formData.details == "") {
        this.$toast("请输入情况说明");
        return;
      }
      if (idc == 0) {
        this.addCustomerGen();
      } else {
        this.editCustomerGen();
      }
    },

    // 修改
    editCustomerGen() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      editCustomerGen(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 新增
    addCustomerGen() {
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addCustomerGen(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(res.message);
          }, 500);
          setTimeout(() => {
            history.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  /deep/ .van-cell {
    padding: 0;
    font-size: 12px;
    background: none;
    height: 100%;
  }
  /deep/ .van-field__body {
    height: 100%;
  }
  .head {
    .icon-goutongjiaoliu {
      font-size: 54px;
    }
  }
  .container_wrap {
    padding: 70px 75px 66px;
    font-size: 22px;
    color: #3c3c3c;
    .info {
      margin-bottom: 80px;
      .txt {
        margin-bottom: 30px;
        align-items: flex-start;
        .label {
          flex-shrink: 0;
          width: 160px;
          white-space: nowrap;
        }
        .cont {
          flex: 1;
          .edit_wrap {
            .check_box {
              width: 100%;
              font-size: 22px;
              margin: 15px 0 10px;
            }
            .input {
              // width: 300px;
              margin: 0;
            }
          }
        }
      }
    }
    .block {
      .title {
        font-size: 24px;
        margin-bottom: 40px;
        .iconfont {
          font-size: 42px;
          margin-right: 12px;
        }
      }
      .item {
        margin-bottom: 45px;
      }
      .input {
        border-bottom: 1px dashed #c3c3c3;
        height: 60px;
        padding: 0 12px;
      }
      .detail {
        margin: 70px auto 0;
        .tit {
          color: #aaaaaa;
          padding-left: 23px;
        }
        .textarea {
          background: #fafafa;
          margin-top: 20px;
          height: 400px;
          padding: 20px;
          box-sizing: border-box;
          /deep/ .van-field__control {
            height: 100%;
          }
        }
      }
    }
    .custom_btn {
      margin-top: 75px;
    }
  }
}
</style>